import { DialogUI } from '../Interface';
import SimpleTaskDeadLineNotificationPage from './SimpleTaskDeadLineNotificationPage';

const SimpleTaskDeadLineNotificationDialog = ({ open, handleClose }) => {
  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Feladat lejárat kezelő"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <SimpleTaskDeadLineNotificationPage
        dialog={{
          handleClose: handleClose,
        }}
      />
    </DialogUI>
  );
};

export default SimpleTaskDeadLineNotificationDialog;
